import { fetchAPI } from "../config";

export const getRegisterNode = async (body) => {
    const data = await fetchAPI("/ssm_api_node/registernode", body);
    return data;
}
